import { create } from "zustand";

export const useProjectInfoStore = create((set) => ({
  projectInfoZustandState: null, // Initial state
  setProjectInfoZustandState: (data) => set({ projectInfoZustandState: data }), // Setter function
}));
